import React from 'react';
import { Link } from 'dva/router';
import LinesEllipsis from 'react-lines-ellipsis';

export default ({novel_id, name, pic, reason}) => (
<div>
    <Link to={`/book/detail/${novel_id}`}>
        <div style={{
            width: '100%',
            paddingBottom: '128.6%',
            height: '0',
            backgroundImage: `url(${pic})`,
			backgroundSize: 'cover',
			backgroundPosition: 'center',
        }} />
        <div style={{
            fontSize: '14px',
            lineHeight: '22px',
            color: '#333333',
            marginTop: '10px',
        }}>
			<LinesEllipsis text={name} maxLine={1} />
        </div>
        <div style={{
            fontSize: '12px',
            lineHeight: '17px',
            color: '#999999',
            marginTop: '4px',
        }}>
			<LinesEllipsis text={reason} maxLine={1} />
        </div>
    </Link>
</div>
)



// WEBPACK FOOTER //
// ./src/component/book/styl_brief_6.js